import { IBriefPricingResponse } from "@shared/lib/types/pricingWorkload";
import { Users } from "lucide-react";
import styles from "../styles.module.scss";

type AssignedPoc = IBriefPricingResponse["assignedPricingPocV2"][number];

interface PocTagsProps {
  pocs: AssignedPoc[];
}

export function PocTags({ pocs }: PocTagsProps) {
  return (
    <div className={styles.pocTagsCard}>
      <div className={styles.pocTagsLabel}>
        <Users size={12} />
        Pricing POCs
      </div>

      {!pocs.length ? (
        <span className={styles.pocTagsEmpty}>
          No creators on the pricing queue yet
        </span>
      ) : (
        <div className={styles.pocTagsList}>
          {pocs.map((p) => {
            const name =
              `${p.user.firstName ?? ""} ${p.user.lastName ?? ""}`.trim();
            return (
              <button
                key={p._id}
                type="button"
                className={`${styles.pocTag} ${styles.pocTagSelected}`}
                title={`Show ${p.count} creator${
                  p.count !== 1 ? "s" : ""
                } for ${name}`}
              >
                <span>{name || "—"}</span>
                <span className={styles.pocTagCount}>{p.count}</span>
              </button>
            );
          })}
        </div>
      )}
    </div>
  );
}
